import { Box, Spinner, Text } from '@lego/klik-ui';
import { useMemo } from 'react';
import { useDeviceFile } from '@/hooks/device';

type Props = {
  workspaceId: number;
  deviceId: number;
  fileId: number;
};

const StatusMessage = ({ message, isError = true }: { message: string; isError?: boolean }) => (
  <Box background="white" p={4}>
    <Text color={isError ? 'red.600' : undefined}>{message}</Text>
  </Box>
);

export const DeviceFileContent = ({ deviceId, workspaceId, fileId }: Props) => {
  const { data: deviceFile, error, isLoading } = useDeviceFile(deviceId, fileId, workspaceId);

  const decodedContent = useMemo(() => {
    if (!deviceFile?.fileContents) return null;
    try {
      return atob(deviceFile.fileContents);
    } catch {
      return null;
    }
  }, [deviceFile?.fileContents]);

  if (isLoading) {
    return (
      <Box background="white" p={4}>
        <Spinner margin={'auto'} size={'sm'} />
      </Box>
    );
  }

  if (error) return <StatusMessage message="Failed to load file" />;
  if (!deviceFile) return <StatusMessage message="File not found" />;
  if (decodedContent === null) return <StatusMessage message="Failed to decode file content" />;
  if (decodedContent === '') return <StatusMessage message="File is empty" />;

  return (
    <Box background="white">
      <Text background="#f1f1f1" boxShadow="inner" p={4} whiteSpace="pre-wrap">
        {decodedContent}
      </Text>
    </Box>
  );
};
